import { ReactElement, ReactNode } from 'react';

import { Link, Stack, Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

export interface UserIdentityProps {
  fullName: string;
  email: string;
  nameVariant?: Variant;
  onNameClick?: () => void;
  badge?: ReactNode;
}

export const UserIdentity = ({
  fullName,
  email,
  nameVariant = 'body1',
  onNameClick,
  badge,
}: UserIdentityProps): ReactElement => (
  <Stack direction="column">
    <Stack direction="row" alignItems="center" spacing={1}>
      {onNameClick ? (
        <Link
          variant={nameVariant}
          underline="hover"
          noWrap
          sx={{ minWidth: 0, cursor: 'pointer' }}
          onClick={onNameClick}
        >
          {fullName}
        </Link>
      ) : (
        <Typography variant={nameVariant} noWrap>
          {fullName}
        </Typography>
      )}
      {badge}
    </Stack>
    <Typography variant="caption" color="text.secondary" noWrap>
      {email}
    </Typography>
  </Stack>
);
